export const PATH_VISIBILITY = "/app/visibility";

export const rankingRoutes = {
    root: (): string => `${PATH_VISIBILITY}`,
};
